var map = {
	"./de/group-logo.png": "FBHD",
	"./en/group-logo.png": "gM8s",
	"./es/group-logo.png": "ixLk",
	"./fr/group-logo.png": "ieBW",
	"./ja/group-logo.png": "5NUx",
	"./ko/group-logo.png": "PrSz",
	"./pt/group-logo.png": "YhXh",
	"./ru/group-logo.png": "2eF7",
	"./tc/group-logo.png": "MnMX",
	"./th/group-logo.png": "Lc2O"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fOM+";